import React from 'react';
import { useSearchParams } from 'react-router-dom';
import StudyNotesPage from './StudyNotesPage';
import BookNotesListPage from '../book/BookNotesListPage';

const StudyNotesSwitcher = () => {
  const [searchParams] = useSearchParams();
  const bookId = searchParams.get('bookid') || searchParams.get('bookId');

  if (bookId) {
    return <BookNotesListPage />;
  }

  return <StudyNotesPage />;
};

export default StudyNotesSwitcher;

